import { render, staticRenderFns } from "./qsDetil.vue?vue&type=template&id=494f20ed&scoped=true&"
import script from "./qsDetil.vue?vue&type=script&lang=js&"
export * from "./qsDetil.vue?vue&type=script&lang=js&"
import style0 from "./qsDetil.vue?vue&type=style&index=0&id=494f20ed&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f20ed",
  null
  
)

export default component.exports